import FormWriter from './lib/form_writer';
import Actions from './lib/actions';

/**
 * The entry point a host application uses to drive dashboard interactions from
 * its own extension controllers.
 *
 * Host controllers run in the host's own Stimulus application, and the host's
 * layout decides which bundle evaluates first, so they cannot resolve a
 * controller instance registered here or subclass a class from this bundle at
 * module-evaluation time. Reaching this global inside an event handler is late
 * enough that both bundles have loaded.
 */
const ChartingDashboard = { Actions, FormWriter };

if (typeof window !== 'undefined') {
  window.ChartingDashboard = ChartingDashboard;
}

export default ChartingDashboard;
